import UserAvatar from '@/assets/icons/user-avatar.svg?react'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './UserMessage.module.scss'

export default memo<{message: string}>(function UserMessage({message}) {
  return (
    <div className={style.UserMessage}>
      <VisuallyHidden as='h3'>{`Your message: ${message}`}</VisuallyHidden>
      <div className={style.UserAvatar}>
        <UserAvatar aria-hidden />
      </div>
      <div className={style.UserMessageContent} aria-hidden>
        {message}
      </div>
    </div>
  )
})
